<template>
  <div>
    <el-table :data="pageData.items" height="480" stripe border :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
      <el-table-column prop="last_modified_time" label="操作时间" sortable />
      <el-table-column prop="user_name" label="操作人" />
      <el-table-column prop="server_type_desp" label="系统名称" />
      <el-table-column prop="version_manage_name" label="版本号" />
      <el-table-column prop="upgrade_status_desp" label="升级状态" />
      <el-table-column prop="upgrade_desc" label="升级描述" />
    </el-table>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </div>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    const deviceId = this.deviceId
    return Backend.initListPageNoCache(this, 'upgrade_task_device', {
      params: {
        device_id: deviceId
      }
    })
  },

  props: ['deviceId'],

  methods: {
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    }
  }
}
</script>
